import { render, staticRenderFns } from "./TransactionSectionDigitalSignature.vue?vue&type=template&id=2c24caa0"
import script from "./TransactionSectionDigitalSignature.vue?vue&type=script&lang=js"
export * from "./TransactionSectionDigitalSignature.vue?vue&type=script&lang=js"
import style0 from "./TransactionSectionDigitalSignature.vue?vue&type=style&index=0&id=2c24caa0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports